import {Column} from 'components'
import styled from 'styled-components'

export const ScrollableColumn = styled(Column).attrs({flex: 1, minHeight: 0})`
  overflow: auto;
`
